import React, { PropsWithChildren } from "react";
import { InfoTooltipStyle as S } from "./InfoTooltip.style";
import { PTooltipProps } from "@prime/PTooltip/PTooltip";

export const InfoTooltip: React.FC<
  PropsWithChildren<{ className?: string; wrapperClassName?: string } & PTooltipProps>
> = ({ children, ...props }) => {
  return (
    <S.InfoTooltip className="info-tooltip">
      <S.TooltipWrapped tooltip={children} materialIcon="info" {...props} />
    </S.InfoTooltip>
  );
};
